module.exports = __webpack_public_path__ + "f9a7284a3404c337048cb8cd0d554457.png";